import React, { useState, useEffect, useMemo } from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { createPortal } from "react-dom";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { createMapping, fetchLinkedItems, fetchAllDepartments } from "../../../../../redux/customer/customerSlice";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";
import { useParams } from "react-router-dom";
const AssignDepartment = ({ onOpen, onClose, locationId }) => {
  const dispatch = useDispatch();
  const { departmentList, linkedDepartments = [], currentCustomer } = useSelector((state) => state.customer);
 const { userId } = useParams();
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [popup, setPopup] = useState({
    type: "",
    visible: false,
    title: "",
    message: "",
  });

  // Fetch departments when dialog opens
  useEffect(() => {
    if (!onOpen || !locationId || !userId) return;

    dispatch(fetchLinkedItems({ id: locationId, userId }));
    // dispatch(fetchAllDepartments(userId));
  }, [onOpen, locationId, userId, dispatch]);

  // Preselect linked departments (after removing null values if any)

  const cleanLinkedDepartments = useMemo(
    () => linkedDepartments?.filter(Boolean) || [],
    [linkedDepartments],
  );

  useEffect(() => {
    setSelectedDepartments(cleanLinkedDepartments.map((d) => d._id));
  }, [cleanLinkedDepartments]);

  const handleCheck = (id) => {
    setSelectedDepartments((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  //SAVE DATA
  const handleSave = async () => {
    try {
      const res = await dispatch(
        createMapping({
          userId,
          data: {
            parentId: locationId,
            childIds: selectedDepartments,
          },
        }),
      ).unwrap();
      if (res?.success) {
        setPopup({
          type: "success",
          visible: true,
          title: "Success",
          message: res?.message || "Departments mapped successfully",
        });

        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        setPopup({
          type: "error",
          visible: true,
          title: "Error",
          message: res?.message || "Failed to assign departments",
        });
      }
    } catch (err) {
      console.error("Mapping error:", err);
      const errorMessage = 
        err?.message || 
        err?.data?.message || 
        (typeof err === 'string' ? err : "Something went wrong");

      setPopup({
        type: "error",
        visible: true,
        title: "Error",
        message: errorMessage,
      });
    }
  };

  // Auto-close popup
  useEffect(() => {
    if (popup.visible) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, visible: false }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [popup.visible]);

  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div className="p-4">
          <h2 className="text-lg font-semibold text-[#06513D] mb-4">
            Add Departments
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
            {[...(departmentList || [])]
              .sort((a, b) => {
                // Get the index in the already linked items list
                const aIndex = (linkedDepartments || []).findIndex(
                  (d) => d?._id === a._id,
                );

                const bIndex = (linkedDepartments || []).findIndex(
                  (d) => d?._id === b._id,
                );

                const aIsLinked = aIndex !== -1;
                const bIsLinked = bIndex !== -1;

                // If both are linked, sort by their index in the linkedItems array
                if (aIsLinked && bIsLinked) {
                  return aIndex - bIndex;
                }

                // Otherwise, just ensure linked ones are at the top
                return bIsLinked - aIsLinked;
              })
              .map((dept) => (
                <label
                  key={dept._id}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedDepartments.includes(dept._id)}
                    onChange={() => handleCheck(dept._id)}
                    className="w-4 h-4 accent-[#06513D]"
                  />
                  <span className="text-[15px] font-medium text-[#2D2D2D]">
                    {dept.name}
                  </span>
                </label>
              ))}
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <Button onClick={onClose}>Cancel</Button>

            <Button
              type="primary"
              style={{ background: "#06513D" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </DailogBox>
      {/*  Popup */}
      {popup.visible &&
        createPortal(
          <div className="fixed inset-0 bg-black/30 z-[10001] flex items-center justify-center">
            <PopupCard
              type={popup.type}
              title={popup.title}
              message={popup.message}
            />
          </div>,
          document.body,
        )}
    </div>
  );
};

export default AssignDepartment;
